module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "contact-form lianxi_section2 section"
  }, [_c('div', {
    staticClass: "lianxibiao"
  }, [_c('div', {
    staticClass: "lianxibiao1"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "d-flex top-30 donghuasun",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s",
      "visibility": "visible",
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_c('p', {
    staticClass: "shoujino",
    domProps: {
      "innerHTML": _vm._s(_vm.lianxiwomen.content)
    }
  }), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex donghuasun lianxibuxians",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.8s",
      "visibility": "visible"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_c('p', {
    staticClass: "zxdh",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("咨询电话")]), _vm._v(" "), _c('p', {
    staticClass: "zxdh1",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(_vm._s(_vm.qiyeinfo.phone))])])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "biaodan1 donghuaRight",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_c('div', {
    staticClass: "biaodan2"
  }, [_vm._v("\n            联系我们\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "biaodan3"
  }, [_c('div', {
    staticClass: "left",
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    }
  }, [_c('p', [_c('label', [_vm._v("姓名：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    staticStyle: {
      "width": "100%",
      "border": "0px",
      "padding": "10px"
    },
    attrs: {
      "type": "messname",
      "placeholder": "请输入您的称呼",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '请输入您的称呼'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('label', [_vm._v("电话：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    staticStyle: {
      "width": "100%",
      "border": "0px",
      "padding": "10px"
    },
    attrs: {
      "type": "messtel",
      "placeholder": "请输入您的联系电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '请输入您的联系电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("内容：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    staticStyle: {
      "width": "100%",
      "border": "1px solid #eee",
      "padding": "10px",
      "height": "100px",
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "messtitle",
      "name": "message",
      "cols": "20",
      "rows": "7",
      "placeholder": "请输入您的留言内容",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '请输入您的留言内容'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "margin-bottom": "30px",
      "background": "#e40230",
      "color": "#ffffff"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("提交")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "contact-form section-padding3 lianxi_section3 section"
  }, [_c('div', {
    staticClass: "lianxi_sun1"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "lianxi_sun3 donghuaRight",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.8s",
      "visibility": "visible",
      "z-index": "0"
    }
  }, [_c('p', {
    staticClass: "rencai",
    domProps: {
      "innerHTML": _vm._s(_vm.linian1.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lianxi_sun4 donghuaRight",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1.3s",
      "visibility": "visible"
    }
  }, [_c('p', {
    staticClass: "rencai",
    domProps: {
      "innerHTML": _vm._s(_vm.linian2.content)
    }
  })])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('section', {
    staticClass: "contact-form section-padding3 lianxi_section5 section"
  }, [_c('div', {
    staticClass: "zpgw01"
  }, [_c('div', {
    staticClass: "zpgw01-1"
  }, [_vm._m(7), _vm._v(" "), _vm._l((_vm.zhaopin), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zpgw01-1-2 donghuasunfadeIn",
      staticStyle: {
        "cursor": "pointer",
        "animation-duration": "1s",
        "animation-delay": "0.8s",
        "visibility": "visible"
      },
      on: {
        "click": function($event) {
          return _vm.openPopup(item.content)
        }
      }
    }, [_vm._m(8, true), _vm._v(" "), _c('p', {
      staticClass: "zhiyefazhan_02",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v("招聘人数 : " + _vm._s(item.ext_zhaopinrenshu) + "人")]), _vm._v(" "), _c('p'), _c('div', {
      staticClass: "zp0112-1"
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
      staticClass: "chchaziti_s",
      staticStyle: {
        "margin-top": "100px"
      }
    }, [_c('span', [_vm._v(_vm._s(item.ext_gongzuodidian))])])])
  }), _vm._v(" "), (_vm.showPopup) ? _c('div', {
    staticClass: "popup-container",
    on: {
      "click": _vm.guanbitc
    }
  }, [_c('div', {
    staticClass: "zuixintc_S",
    staticStyle: {
      "width": "50%",
      "text-align": "left",
      "background": "#fff",
      "padding": "20px",
      "border-radius": "10px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.zhaopininfo)
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#E91E63",
      "cursor": "pointer",
      "padding": "10px 5px",
      "border-radius": "0px 5px 5px 0px",
      "color": "#fff"
    },
    on: {
      "click": _vm.guanbitc
    }
  }, [_vm._v("关闭")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "footer-area section-padding9 section"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('h3', {
    staticClass: "mb-4 phone_weibu_zt1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "20px"
    }
  }, [_vm._v("专业技术团队 提供全方位系统解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4",
    staticStyle: {
      "color": "#7a7a7a",
      "line-height": "60px"
    }
  }, [_vm._v("如有任何疑问 请随时与我们联系")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    attrs: {
      "type": "messname",
      "placeholder": "您的姓名",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的姓名'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    attrs: {
      "type": "messtel",
      "placeholder": "您的电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    attrs: {
      "type": "messtitle",
      "placeholder": "您的留言",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的留言'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "background": "rgb(0 100 207)"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("立即提交")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright weibu_sun"
  }, [_c('div', {
    staticClass: "container weibu912",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "weibu_c donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.5s"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.zhandianinfo.copyright))]), _vm._v(" "), _c('p', [_vm._v("总部公司 : " + _vm._s(_vm.qiyeinfo.address))]), _vm._v(" "), _c('p', [_vm._v("服务热线 : " + _vm._s(_vm.qiyeinfo.mobile))]), _vm._v(" "), _c('p', [_vm._v("主营产品 : " + _vm._s(_vm.qiyeinfo.other))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zhandianinfo.icp) + " "), _vm._m(11)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_vm._v("拿度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding lianxi_section1 section",
    staticStyle: {
      "background-size": "auto 100% !important"
    }
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible",
      "color": "#E91E63"
    }
  }, [_vm._v("CONTACT US")])]), _vm._v(" "), _c('div', {
    staticClass: "animate bounce animated",
    staticStyle: {
      "width": "100%",
      "height": "100px",
      "line-height": "100px",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/shubiao.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex donghuaDown",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.2s",
      "visibility": "visible"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_c('span', {
    staticClass: "llx1",
    staticStyle: {
      "border-bottom": "0px",
      "color": "#e40230"
    }
  }, [_vm._v("联系方式 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoujiok"
  }, [_c('p', {
    staticStyle: {
      "box-sizing": "border-box",
      "margin-top": "0px",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                  公司地址：\n                ")]), _c('div', {
    staticClass: "zzz123"
  }, [_vm._v("山东省烟台经济技术开发区珠江路32号3号楼")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "box-sizing": "border-box",
      "margin-top": "0px",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                  业务电话：\n                ")]), _c('div', {
    staticClass: "zzz123"
  }, [_vm._v("18562255186"), _c('br'), _vm._v("18596163696"), _c('br'), _vm._v("18562255176")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "box-sizing": "border-box",
      "margin-top": "0px",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                  公司传真：\n                ")]), _c('div', {
    staticClass: "zzz123"
  }, [_vm._v("0535-6936196")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "box-sizing": "border-box",
      "margin-top": "0px",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                  企业邮箱：\n                ")]), _c('div', {
    staticClass: "zzz123"
  }, [_vm._v("ytndkj@163.com   2141299192@qq.com")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "box-sizing": "border-box",
      "margin-top": "0px",
      "margin-bottom": "1rem"
    }
  }, [_vm._v("\n                  QQ         ：2141299192\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex donghuasun lianxibuxians",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.9s",
      "visibility": "visible"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_c('div', {
    staticClass: "image-containerc-lx"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera-lx"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb-lx"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lianxi_sun2"
  }, [_c('img', {
    staticClass: "donghuaLeft",
    staticStyle: {
      "height": "100%",
      "animation-duration": "1s",
      "animation-delay": "0.5s",
      "visibility": "visible"
    },
    attrs: {
      "src": "/static/assets/images/lianxibn3.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "donghuaLeft",
    staticStyle: {
      "height": "100%",
      "margin-left": "30%",
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "src": "/static/assets/images/lianxibn3z.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "contact-form section-padding3 lianxi_section4 section"
  }, [_c('div', {
    staticClass: "zyfz001"
  }, [_c('div', {
    staticClass: "zyfz002",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_c('img', {
    staticClass: "zhiyefazhan",
    attrs: {
      "src": "/static/assets/images/zhiyefazhan.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zyfz003"
  }, [_c('div', {
    staticClass: "zyfz3-1 donghuaLeft",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.2s",
      "visibility": "visible"
    }
  }, [_c('p', {
    staticClass: "zhiyefazhan_01",
    staticStyle: {
      "font-size": "20px",
      "color": "#cccccc6b"
    }
  }, [_vm._v("REVIEW SYSTEM")]), _vm._v(" "), _c('p', {
    staticClass: "zhiyefazhan_02",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("01 科学的任职资格评审制度")]), _vm._v(" "), _c('p', {
    staticClass: "zhiyefazhan_03"
  }, [_vm._v("针对每位员工能力素质差异，制定个人职业发展计划 通过知识技能培训，提升工作能力，经过科学评审，获得轮岗/晋升机会")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "zyfz3-2 donghuaLeft",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.5s",
      "visibility": "visible"
    }
  }, [_c('p', {
    staticClass: "zhiyefazhan_01",
    staticStyle: {
      "font-size": "20px",
      "color": "#cccccc6b"
    }
  }, [_vm._v("ENTERPRISE UNIVERSITY")]), _vm._v(" "), _c('p', {
    staticClass: "zhiyefazhan_02",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("02 拿度企业大学")]), _vm._v(" "), _c('p', {
    staticClass: "zhiyefazhan_03"
  }, [_vm._v("与知名院校合作，为员工提供高起专/专升本/工程硕士/MBA学历教育 完善的培训体系，为不同层级员工提供全方位技能/专业/管理的内外部培训课程")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "zyfz3-3"
  }, [_c('p', {
    staticClass: "donghuaRight zhiyefazhan_01",
    staticStyle: {
      "font-size": "20px",
      "color": "#cccccc6b",
      "animation-duration": "0.5s",
      "animation-delay": "0.8s",
      "visibility": "visible"
    }
  }, [_vm._v("\n              PROMOTION")]), _vm._v(" "), _c('p', {
    staticClass: "donghuaRight zhiyefazhan_02",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "animation-duration": "0.5s",
      "animation-delay": "0.8s",
      "visibility": "visible"
    }
  }, [_vm._v("\n              03 多样的员工晋升通道")]), _vm._v(" "), _c('p', {
    staticClass: "zhiyefazhan_03"
  }, [_vm._v("提供多元化晋升路径、制定明确的晋升规划、提供培训和发展机会、建立良好的激励机制。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zpgw01-1-1 donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.2s",
      "visibility": "visible"
    }
  }, [_c('p', {
    staticClass: "zhiyefazhan_02",
    staticStyle: {
      "color": "#E91E63"
    }
  }, [_vm._v("RECRUITING POSITIONS")]), _vm._v(" "), _c('p', {
    staticClass: "rencai1",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("招聘岗位")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/lxwmzpgw.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_a donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.3s"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logob.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-counter"
  }, [_c('div', {
    staticClass: "image-containerc"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_b donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('p', [_vm._v("工业物联网整体解决方案服务商")]), _vm._v(" "), _c('p', [_vm._v("智能传感解决方案专家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "5px"
    },
    attrs: {
      "src": "/static/assets/images/gongan.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68ad4c8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ContactUs.vue
// module id = 108
// module chunks = 0